module.exports = __webpack_public_path__ + "img/am.bc051674.svg";